/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { Layout, Menu } from 'antd';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AppMenu } from '@constants/app-menus';
import './Sidebar.scss';

const { Sider } = Layout;
const { SubMenu } = Menu;

interface SidebarProps {
  menus: AppMenu;
}

const Sidebar: React.FC<SidebarProps> = ({ menus }) => {
  const [selectedKey, setSelectedKey] = useState(null);
  const [openKey, setOpenKey] = useState(null);
  const router = useLocation();

  React.useEffect(() => {
    if (menus.length > 0) {
      for (const menu of menus) {
        if (menu.isParent) {
          for (const sub of menu.subMenu) {
            if (sub.linkTo.includes(router.pathname)) {
              setOpenKey(menu.key);
              setSelectedKey(sub.subKey);
              break;
            }
          }
          continue;
        }
        if (menu.linkTo.includes(router.pathname)) {
          setOpenKey(null);
          setSelectedKey(menu.key);
          break;
        }
      }
    }
  }, [menus]);

  const history = useHistory();
  const [collapsed, setCollapsed] = useState<boolean>(false);

  const onCollapse = (_collapsed: boolean) => {
    setCollapsed(_collapsed);
  };

  return (
    <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} trigger={null}>
      <img
        src={
          process.env.REACT_APP_BASE_WHITE_LOGO ||
          'https://swaps-bucket.s3.amazonaws.com/Group%2024.png-2022-08-30T06%3A13%3A35.680Z'
        }
        alt="logo"
        className="logo"
      />
      <Menu
        theme="dark"
        defaultSelectedKeys={['1']}
        selectedKeys={[selectedKey]}
        openKeys={[openKey]}
        mode="inline"
        forceSubMenuRender
      >
        {menus.map((menu) => {
          if (menu.hidden) {
            return null;
          }
          if (menu.isParent && menu.subMenu) {
            return (
              <SubMenu
                key={`${menu.key}`}
                icon={menu.Icon && <menu.Icon />}
                title={menu.title}
                onTitleClick={({ key }) => {
                  if (key === openKey) {
                    setOpenKey(null);
                    return;
                  }
                  setOpenKey(key);
                }}
              >
                {menu.subMenu.map((sub) => {
                  if (sub.hidden) {
                    return null;
                  }
                  return (
                    <Menu.Item key={`${sub.subKey}`} icon={sub.Icon && <sub.Icon />}>
                      <Link onClick={() => setSelectedKey(`${sub.subKey}`)} to={sub.linkTo}>
                        {sub.title}
                      </Link>
                    </Menu.Item>
                  );
                })}
              </SubMenu>
            );
          }
          return (
            <Menu.Item key={`${menu.key}`} icon={menu.Icon && <menu.Icon />}>
              {menu.linkTo ? (
                <Link onClick={() => setSelectedKey(`${menu.key}`)} to={menu.linkTo}>
                  {menu.title}
                </Link>
              ) : (
                // eslint-disable-next-line jsx-a11y/interactive-supports-focus
                <a
                  role="button"
                  onClick={() => {
                    if (menu.action) {
                      menu.action();
                    }
                    if (menu.title === 'Super Admin') {
                      history.push('/dashboard');
                    }
                  }}
                >
                  {menu.title}
                </a>
              )}
            </Menu.Item>
          );
        })}
      </Menu>
    </Sider>
  );
};

export default Sidebar;
